import { inputAdornmentClasses, selectClasses, svgIconClasses } from '@mui/material';
// import type { Components } from '@mui/material/styles';
import { KeyboardArrowDownRounded } from '@mui/icons-material';

import {
  fontSizeLarge,
  fontSizeMedium,
  fontSizeSmall,
  fontSizeXSmall,
  iconSizeLarge,
  iconSizeMedium,
  iconSizeSmall,
  iconSizeXSmall,
  largeSize,
  mediumSize,
  smallSize,
  xSmallSize,
} from '@/mui/components/constants';
import { SHAPE_CIRCULAR, SHAPE_SQUARE } from '@/mui/constants';

const fontSizes = {
  xSmall: fontSizeXSmall,
  small: fontSizeSmall,
  medium: fontSizeMedium,
  large: fontSizeLarge,
};

const sizes = {
  xSmall: xSmallSize,
  small: smallSize,
  medium: mediumSize,
  large: largeSize,
};

const iconSizes = {
  xSmall: iconSizeXSmall,
  small: iconSizeSmall,
  medium: iconSizeMedium,
  large: iconSizeLarge,
};

export const CUSTOM_ATTRIBUTE_SHAPE = 'data-0';

export default function MUISelect() /* : Components['MuiSelect'] */ {
  return {
    defaultProps: {
      elevation: 15,
      IconComponent: KeyboardArrowDownRounded,
      fullWidth: true,
      MenuProps: {
        MenuListProps: {
          disablePadding: true,
        },
      },
    },
    styleOverrides: {
      root: {
        padding: 0,
        cursor: 'pointer',
        overflow: 'auto',
      },
      select: {
        top: 0,
        paddingLeft: '12px',
        paddingRight: '12px',
        paddingTop: 0,
        paddingBottom: 0,
        fontSize: 14,
        lineHeight: 1.4,
        display: 'inline-block',
        alignItems: 'center',
        minHeight: 0,
        // marginRight: '32px',
      },
      icon: {
        fontSize: 'inherit',
      },
    },
    variants: [
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_SQUARE },
        style: {
          borderRadius: 0,
        },
      },
      {
        props: { [CUSTOM_ATTRIBUTE_SHAPE]: SHAPE_CIRCULAR },
        style: {
          borderRadius: '100vw',
        },
      },
      ...Object.keys(fontSizes).map((size) => {
        const fontSize = fontSizes[size as keyof typeof fontSizes];
        const inputSize = sizes[size as keyof typeof sizes];
        const iconSize = iconSizes[size as keyof typeof iconSizes];

        return {
          props: { size },
          style: {
            minHeight: inputSize,
            [`& .${selectClasses.select}`]: {
              fontSize,
            },
            [`& .${selectClasses.icon}`]: {
              fontSize: iconSize,
            },
            [` .${inputAdornmentClasses.root}`]: {
              fontSize: iconSize,
              minHeight: inputSize,

              [`& > .${svgIconClasses.root}`]: {
                fontSize: iconSize,
                minWidth: inputSize,
              },
            },
          },
        };
      }),
    ],
  };
}
